module.exports = __webpack_public_path__ + "bradavice_5_after_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/dermatologie/bradavice_5_after_tn.jpg
// module id = 1405
// module chunks = 0